import {
  changeLocationBySelectAddress, changeLocationBySelectLocation,
  clearStoredSelectedUserAddress, getStoredCurrLocation,
  getStoredSelectedUserAddress, getStoreLastSelected,
  setStoredCurrLocation, setStoredSelectedUserAddress,
} from '@m2h/common/utils/location';
import { LocatinStatus, LocatinType } from '@/src/sub_packages/homepage/address_bar/constant';

const hasObjectData = (value) => value && typeof value === 'object' && Object.keys(value).length > 0;

const getAddressId = (address) => {
  const addressId = Number(address?.addressId);
  return Number.isSafeInteger(addressId) && addressId > 0 ? addressId : null;
};

// 此处存、取、删地址，是跨页面、跨bundle行为
// 需使用storage存储，且统一使用顶层window的
// 获取首页已选地址
export const homeSelectedUserAddress = () => {
  const currentLocation = getStoredCurrLocation();
  if (Number(currentLocation?.type) !== LocatinType.userAddress) return null;
  const address = getStoredSelectedUserAddress();
  return hasObjectData(address) ? address : null;
};

export const updateAddress = (address) => {
  const cachedAddress = getStoredSelectedUserAddress();
  const cachedAddressId = getAddressId(cachedAddress);
  const updatedAddressId = getAddressId(address);
  if (!cachedAddressId || cachedAddressId !== updatedAddressId) return;

  setStoredSelectedUserAddress(address);
  const currentLocation = getStoredCurrLocation();
  if (Number(currentLocation?.type) === LocatinType.userAddress) {
    setStoredCurrLocation({
      ...currentLocation,
      ...address,
      detail: address,
      locateStatus: currentLocation.locateStatus,
      type: currentLocation.type,
    });
  }
};

export const deleteAddress = (addressId) => {
  const cachedAddress = getStoredSelectedUserAddress();
  const cachedAddressId = getAddressId(cachedAddress);
  const deletedAddressId = getAddressId({ addressId });
  if (!cachedAddressId || cachedAddressId !== deletedAddressId) return;

  clearStoredSelectedUserAddress();
  const currentLocation = getStoredCurrLocation();
  if (Number(currentLocation?.type) === LocatinType.userAddress) {
    // 删除当前收货地址后仅保留坐标和地址名称，避免顶层联系人、电话等字段残留。
    setStoredCurrLocation({
      latitude: currentLocation?.latitude,
      longitude: currentLocation?.longitude,
      poiName: currentLocation?.poiName || currentLocation?.name,
      name: currentLocation?.name || currentLocation?.poiName,
      detail: {},
      locateStatus: LocatinStatus.overdueAddress,
      type: LocatinType.overdueAddress,
    });
  }
};

export const didSelectAddress = (address) => {
  changeLocationBySelectAddress(address).catch(() => {
    console.error('[SLUserAddress] didSelectAddress failed');
  });
};

export const didSelectLocation = (address) => {
  changeLocationBySelectLocation(address).catch(() => {
    console.error('[SLUserAddress] didSelectLocation failed');
  });
};

// 地图选址缓存
// this.lastSelectedLocation = SLUserAddress?.getLastSelectedLocation?.();
export const getLastSelectedLocation = () => {
  return getStoreLastSelected();
};

const SLUserAddress = {
  homeSelectedUserAddress,
  updateAddress,
  deleteAddress,
  didSelectAddress,
  didSelectLocation,
  getLastSelectedLocation,
};

export default SLUserAddress;
